import React, { useEffect } from "react";
import RealMap from "../../Maps/RealMap";
import useDriverTeams from "../../../Sevices/Driver Api/useDriverTeams";


export default function MapPanel({ tasks, agents }) {
  const { teams, fetchDriverTeams } = useDriverTeams();

  useEffect(() => {
    fetchDriverTeams();
  }, [fetchDriverTeams]);

  return (
    <div className="flex-1 bg-gradient-to-br from-yellow-100 to-red-100 z-0 relative">
      <RealMap
        Task={tasks}
        drivers={agents}
        teams={teams}
        showSearch={true}
      />
    </div>
  );
}